export interface TravelTip {
  icon: string;
  title: string;
  content: string;
}

export const saudiTravelTips: TravelTip[] = [
  {
    title: 'Best Time to Visit',
    content: 'November to March offers pleasant weather. Avoid summer months (June-August) when temperatures exceed 45°C. Plan Umrah outside Hajj season for better availability.',
    icon: 'ri-calendar-line'
  },
  {
    title: 'Visa Requirements',
    content: 'Tourist visas are now available online for most nationalities. Umrah visas require sponsorship. Processing takes 24-48 hours. Ensure passport validity of 6+ months.',
    icon: 'ri-passport-line'
  },
  {
    title: 'Cultural Etiquette',
    content: 'Dress modestly in public areas. Women should wear abayas in Makkah and Madinah. Respect prayer times when shops close. Photography restrictions apply at holy sites.',
    icon: 'ri-user-heart-line'
  },
  {
    title: 'Currency & Payments',
    content: 'Saudi Riyal (SAR) is the currency. Credit cards widely accepted. ATMs available everywhere. Tipping is appreciated but not mandatory. Exchange rates are stable.',
    icon: 'ri-money-pound-circle-line'
  },
  {
    title: 'Transportation',
    content: 'Haramain High-Speed Railway connects Makkah-Madinah-Jeddah. Uber and Careem operate in major cities. Hotel shuttles available for holy sites. Rent cars with international license.',
    icon: 'ri-train-line'
  },
  {
    title: 'Health & Safety',
    content: 'Tap water is safe but bottled water preferred. Pharmacies well-stocked. Travel insurance recommended. Emergency services: 997. Hospitals have English-speaking staff.',
    icon: 'ri-heart-pulse-line'
  }
];

export const turkeyTravelTips: TravelTip[] = [
  {
    title: 'Best Time to Visit',
    content: 'April-May and September-October offer ideal weather. Summer (June-August) is peak season for coastal areas. Winter is perfect for Istanbul and skiing in eastern regions.',
    icon: 'ri-calendar-line'
  },
  {
    title: 'Visa Requirements',
    content: 'E-visa available online for most nationalities. UK citizens can stay 90 days visa-free. Processing is instant. Ensure passport validity of 6+ months beyond travel dates.',
    icon: 'ri-passport-line'
  },
  {
    title: 'Cultural Etiquette',
    content: 'Remove shoes when entering mosques and homes. Dress modestly at religious sites. Learn basic Turkish phrases - locals appreciate the effort. Bargaining expected in bazaars.',
    icon: 'ri-user-heart-line'
  },
  {
    title: 'Currency & Payments',
    content: 'Turkish Lira (TRY) is the currency. Cash preferred in smaller establishments. ATMs widely available. Credit cards accepted in cities. Exchange rates can fluctuate.',
    icon: 'ri-money-pound-circle-line'
  },
  {
    title: 'Transportation',
    content: 'Excellent domestic flight network. High-speed trains connect major cities. Istanbul has efficient metro and tram systems. Dolmuş (shared taxis) are economical. Ferries cross the Bosphorus.',
    icon: 'ri-train-line'
  },
  {
    title: 'Health & Safety',
    content: 'Tap water safe in cities but bottled water recommended. Pharmacies abundant and helpful. Travel insurance advised. Emergency: 112. Tourist police available in major areas.',
    icon: 'ri-heart-pulse-line'
  }
];

export const uaeTravelTips: TravelTip[] = [
  {
    title: 'Best Time to Visit',
    content: 'November to March offers perfect weather (20-30°C). Avoid summer (June-September) with extreme heat. Dubai Shopping Festival (January) and Ramadan offer unique experiences.',
    icon: 'ri-calendar-line'
  },
  {
    title: 'Visa Requirements',
    content: 'UK citizens receive free 180-day visa on arrival. Most nationalities get visa-free entry or visa on arrival. Transit visas available for stopovers. Processing is quick and efficient.',
    icon: 'ri-passport-line'
  },
  {
    title: 'Cultural Etiquette',
    content: 'Dress modestly in public areas and malls. Respect Islamic customs during Ramadan. Public displays of affection discouraged. Photography restrictions at government buildings.',
    icon: 'ri-user-heart-line'
  },
  {
    title: 'Currency & Payments',
    content: 'UAE Dirham (AED) is the currency. Credit cards universally accepted. ATMs everywhere. Tipping 10-15% is customary. Currency exchange offices offer competitive rates.',
    icon: 'ri-money-pound-circle-line'
  },
  {
    title: 'Transportation',
    content: 'Dubai Metro is modern and efficient. Taxis are metered and affordable. Uber and Careem widely available. Rental cars easy to obtain. Excellent road infrastructure throughout.',
    icon: 'ri-train-line'
  },
  {
    title: 'Health & Safety',
    content: 'Tap water is safe to drink. World-class healthcare facilities. Travel insurance recommended. Emergency: 999. English widely spoken in hospitals. Very safe destination overall.',
    icon: 'ri-heart-pulse-line'
  }
];

export const moroccoTravelTips: TravelTip[] = [
  {
    title: 'Best Time to Visit',
    content: 'March to May and September to November offer the most pleasant weather. Summers can be very hot inland. The Sahara is best visited in spring or autumn for comfortable temperatures.',
    icon: 'ri-calendar-line'
  },
  {
    title: 'Visa Requirements',
    content: 'UK citizens can visit Morocco visa-free for up to 90 days. Most Western passport holders receive visa-free entry. Ensure your passport is valid for at least 6 months beyond your travel dates.',
    icon: 'ri-passport-line'
  },
  {
    title: 'Cultural Etiquette',
    content: 'Dress modestly, especially in medinas and mosques. Ask permission before photographing locals. Bargaining is expected in souks. Ramadan brings special customs — be respectful of fasting hours.',
    icon: 'ri-user-heart-line'
  },
  {
    title: 'Currency & Payments',
    content: 'Moroccan Dirham (MAD) is the currency. Cash is preferred in medinas and smaller towns. ATMs are widely available in cities. Credit cards accepted in hotels and larger restaurants.',
    icon: 'ri-money-pound-circle-line'
  },
  {
    title: 'Transportation',
    content: 'ONCF trains connect major cities efficiently. CTM buses serve smaller towns. Petit taxis are metered within cities. Grand taxis cover intercity routes. Renting a car is ideal for exploring the Atlas and desert.',
    icon: 'ri-train-line'
  },
  {
    title: 'Health & Safety',
    content: 'Drink bottled water only. Pharmacies are well-stocked and helpful. Travel insurance is strongly recommended. Emergency number: 15 (medical), 19 (police). Morocco is generally safe for tourists.',
    icon: 'ri-heart-pulse-line'
  }
];

export const egyptTravelTips: TravelTip[] = [
  {
    title: 'Best Time to Visit',
    content: 'October to April is ideal with cooler temperatures. Avoid July and August when Cairo and Luxor can exceed 40°C. The Red Sea coast is enjoyable year-round with warm waters.',
    icon: 'ri-calendar-line'
  },
  {
    title: 'Visa Requirements',
    content: 'UK and most Western citizens can obtain a visa on arrival or e-visa online. E-visa processing takes 3–5 business days. Ensure passport validity of at least 6 months. Sinai-only stamp available at some entry points.',
    icon: 'ri-passport-line'
  },
  {
    title: 'Cultural Etiquette',
    content: 'Dress conservatively, especially at religious sites. Remove shoes before entering mosques. Tipping (baksheesh) is customary and expected. Photography at some ancient sites requires a permit.',
    icon: 'ri-user-heart-line'
  },
  {
    title: 'Currency & Payments',
    content: 'Egyptian Pound (EGP) is the currency. Cash is widely used, especially outside tourist areas. ATMs available in cities and resorts. Credit cards accepted at hotels and larger establishments.',
    icon: 'ri-money-pound-circle-line'
  },
  {
    title: 'Transportation',
    content: 'Domestic flights connect Cairo, Luxor, Aswan, and Hurghada efficiently. Nile cruises are a popular way to travel between Luxor and Aswan. Taxis and ride-hailing apps (Uber, Careem) operate in Cairo.',
    icon: 'ri-train-line'
  },
  {
    title: 'Health & Safety',
    content: 'Drink bottled water only. Sunscreen and hydration are essential. Travel insurance is highly recommended. Emergency: 123 (police), 123 (ambulance). Stick to reputable tour operators for site visits.',
    icon: 'ri-heart-pulse-line'
  }
];

export const jordanTravelTips: TravelTip[] = [
  {
    title: 'Best Time to Visit',
    content: 'March to May and September to November are ideal. Summers are hot but dry. Wadi Rum and Petra are best visited in spring or autumn. The Dead Sea is enjoyable year-round.',
    icon: 'ri-calendar-line'
  },
  {
    title: 'Visa Requirements',
    content: 'UK and most Western citizens can obtain a visa on arrival or purchase the Jordan Pass online, which includes entry visa and major attraction tickets. The Jordan Pass offers excellent value for tourists.',
    icon: 'ri-passport-line'
  },
  {
    title: 'Cultural Etiquette',
    content: 'Jordan is one of the most welcoming countries in the region. Dress modestly at religious sites. Accepting tea or coffee when offered is a sign of respect. Jordanians are known for exceptional hospitality.',
    icon: 'ri-user-heart-line'
  },
  {
    title: 'Currency & Payments',
    content: 'Jordanian Dinar (JOD) is the currency and one of the highest-valued in the world. Credit cards widely accepted in hotels and restaurants. ATMs available in cities. Tipping 10% is customary.',
    icon: 'ri-money-pound-circle-line'
  },
  {
    title: 'Transportation',
    content: 'JETT buses connect major cities. Taxis are metered in Amman. Renting a car is the best way to explore Petra, Wadi Rum, and the Dead Sea at your own pace. Uber operates in Amman.',
    icon: 'ri-train-line'
  },
  {
    title: 'Health & Safety',
    content: 'Tap water is technically safe but bottled water is recommended. Jordan is one of the safest countries in the Middle East. Emergency: 911. Travel insurance is advised. Hospitals in Amman are excellent.',
    icon: 'ri-heart-pulse-line'
  }
];

export const travelTips: Record<string, TravelTip[]> = {
  saudiArabia: saudiTravelTips,
  turkey: turkeyTravelTips,
  uae: uaeTravelTips,
  morocco: moroccoTravelTips,
  egypt: egyptTravelTips,
  jordan: jordanTravelTips,

  malaysia: [
    {
      icon: 'ri-calendar-line',
      title: 'Best Time to Visit',
      content: 'Visit between December and February for dry weather. Avoid monsoon season (November-March on east coast). Year-round warm tropical climate.',
    },
    {
      icon: 'ri-restaurant-line',
      title: 'Halal Food Paradise',
      content: 'Malaysia is a halal food capital with 100% halal certification. Try nasi lemak, satay, roti canai, and laksa. Street food is safe and delicious.',
    },
    {
      icon: 'ri-money-pound-circle-line',
      title: 'Currency & Budget',
      content: 'Currency is Malaysian Ringgit (MYR). Very affordable destination. £1 = ~5.5 MYR. Credit cards widely accepted in cities.',
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Prayer Facilities',
      content: 'Mosques and prayer rooms (surau) available everywhere including malls, airports, and tourist attractions. Muslim-majority country.',
    },
    {
      icon: 'ri-plane-line',
      title: 'Getting Around',
      content: 'Excellent public transport in KL (LRT, MRT, monorail). Grab app for taxis. Domestic flights cheap between cities. Rent a car for islands.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Family Safety',
      content: 'Very safe for families and children. English widely spoken. Friendly locals. Excellent healthcare. Family-friendly culture and attractions.',
    },
  ],

  indonesia: [
    {
      icon: 'ri-calendar-line',
      title: 'Best Time to Visit',
      content: 'Dry season April-October is ideal. Lombok has less rain than Bali. Avoid December-February for best weather. Warm tropical climate year-round.',
    },
    {
      icon: 'ri-restaurant-line',
      title: 'Halal Food Everywhere',
      content: 'World\'s largest Muslim nation — halal food guaranteed. Try nasi goreng, rendang, sate, and gado-gado. Lombok is 85% Muslim.',
    },
    {
      icon: 'ri-money-pound-circle-line',
      title: 'Currency & Costs',
      content: 'Currency is Indonesian Rupiah (IDR). Very affordable. £1 = ~19,000 IDR. Bring cash for small vendors. ATMs widely available.',
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Prayer Facilities',
      content: 'Mosques everywhere, especially in Lombok (Muslim-majority island). Prayer rooms in hotels, malls, and tourist areas. Call to prayer heard daily.',
    },
    {
      icon: 'ri-plane-line',
      title: 'Getting Around',
      content: 'Fly to Lombok International Airport. Rent scooter or car for island exploration. Boat transfers to Gili Islands. Grab app available.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Family Safety',
      content: 'Safe for families. Lombok more conservative than Bali. Friendly locals. Basic English in tourist areas. Excellent family resorts.',
    },
  ],

  maldives: [
    {
      icon: 'ri-calendar-line',
      title: 'Best Time to Visit',
      content: 'November to April is dry season with best weather. May-October is monsoon but still warm. Year-round tropical paradise destination.',
    },
    {
      icon: 'ri-restaurant-line',
      title: 'Halal-Certified Resorts',
      content: 'Maldives is a 100% Muslim nation. Many resorts offer halal-certified food and alcohol-free zones. Always confirm halal options when booking.',
    },
    {
      icon: 'ri-money-pound-circle-line',
      title: 'Currency & Budget',
      content: 'Currency is Maldivian Rufiyaa (MVR) but USD widely accepted. Luxury destination — budget £300-£800/night. All-inclusive packages recommended.',
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Prayer Facilities',
      content: 'Muslim nation with prayer facilities in most resorts. Some resorts have dedicated prayer rooms. Qibla direction marked in rooms.',
    },
    {
      icon: 'ri-plane-line',
      title: 'Getting Around',
      content: 'Fly to Male International Airport. Speedboat or seaplane transfers to resorts (included in packages). Each resort is on its own island.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Family Safety',
      content: 'Extremely safe for families. Resorts have kids clubs and family villas. Calm lagoons perfect for children. Snorkeling safe and supervised.',
    },
  ],

  bosnia: [
    {
      icon: 'ri-calendar-line',
      title: 'Best Time to Visit',
      content: 'May-September for warm weather. June-August peak season. Spring and autumn beautiful and less crowded. Winter for skiing in mountains.',
    },
    {
      icon: 'ri-restaurant-line',
      title: 'Halal Food & Culture',
      content: 'Majority Muslim population with authentic halal Bosnian cuisine. Try ćevapi, burek, and baklava. Halal restaurants everywhere.',
    },
    {
      icon: 'ri-money-pound-circle-line',
      title: 'Currency & Budget',
      content: 'Currency is Convertible Mark (BAM). Very affordable destination. £1 = ~2.3 BAM. Cash preferred in smaller towns. ATMs available.',
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Prayer Facilities',
      content: 'Beautiful historic mosques throughout Bosnia. Prayer facilities widely available. Hear adhan (call to prayer) in cities. Rich Islamic heritage.',
    },
    {
      icon: 'ri-plane-line',
      title: 'Getting Around',
      content: 'Fly to Sarajevo International Airport. Rent a car for flexibility. Buses connect major cities. Taxis affordable. Roads scenic but mountainous.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Family Safety',
      content: 'Very safe for families. Warm hospitality. English spoken in tourist areas. European standards. Affordable family-friendly destination.',
    },
  ],
};